import React from 'react';
import { Link } from 'react-router';
import SEOHead from '../../components/seo/seo-head';
import { SEO_CONFIG } from '../../constants/seo-config';
import LoginStore from '../../stores/login-store';
import CONSTANTS from '../../constants/constants';
import PageHeader from '../../components/banners/page-header';
import StartTrialBanner from '../../components/banners/start-trial';
import ContactForm from './contact-form';
import './contact.scss';


export default class Contactus extends React.Component {

  render() {
    const trialBanner = (LoginStore.isLoggedIn()) ? null : <StartTrialBanner {...this.props} />

    return (
      <div className="contact-us">
        <SEOHead {...SEO_CONFIG.contact} />

        <PageHeader eyebrow="Contact" title={<React.Fragment>Get in <em>touch</em></React.Fragment>}>
          <p>Questions about Neurochecklists? Our <Link to="/faqs">FAQs</Link> may already have the answer.</p>
          <p>Otherwise, send us a message below or email <a href={`mailto:${CONSTANTS.CONTACT_EMAIL}`}>{CONSTANTS.CONTACT_EMAIL}</a>.</p>
        </PageHeader>

        <div className="contact-body">
          <ContactForm />
        </div>

        {trialBanner}
      </div>
    )
  }

}
